<div class="overlay">
  <div class="modal">
    <h2 class="title">Procesando</h2>
    <p class="subtitle">Estamos completando tu solicitud</p>
    <br>
    <div class="spinner-container">
      <svg class="spinner" width="56" height="56" viewBox="0 0 50 50" aria-label="Cargando">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
      </svg>
    </div>
  </div>
</div>
